__turbopack_context__.v({
  "actionsRow": "ScrollTest-module__UkQ3Fq__actionsRow",
  "body": "ScrollTest-module__UkQ3Fq__body",
  "feedback": "ScrollTest-module__UkQ3Fq__feedback",
  "hintIcon": "ScrollTest-module__UkQ3Fq__hintIcon",
  "hoverOverlay": "ScrollTest-module__UkQ3Fq__hoverOverlay",
  "info": "ScrollTest-module__UkQ3Fq__info",
  "isActive": "ScrollTest-module__UkQ3Fq__isActive",
  "isSuccess": "ScrollTest-module__UkQ3Fq__isSuccess",
  "progressBar": "ScrollTest-module__UkQ3Fq__progressBar",
  "progressFill": "ScrollTest-module__UkQ3Fq__progressFill",
  "relative": "ScrollTest-module__UkQ3Fq__relative",
  "result-failed": "ScrollTest-module__UkQ3Fq__result-failed",
  "result-success": "ScrollTest-module__UkQ3Fq__result-success",
  "runner": "ScrollTest-module__UkQ3Fq__runner",
  "runnerDanger": "ScrollTest-module__UkQ3Fq__runnerDanger",
  "runnerSuccess": "ScrollTest-module__UkQ3Fq__runnerSuccess",
  "shell": "ScrollTest-module__UkQ3Fq__shell",
  "status-failed": "ScrollTest-module__UkQ3Fq__status-failed",
  "status-initial": "ScrollTest-module__UkQ3Fq__status-initial",
  "status-success": "ScrollTest-module__UkQ3Fq__status-success",
  "statusPill": "ScrollTest-module__UkQ3Fq__statusPill",
  "trackMarks": "ScrollTest-module__UkQ3Fq__trackMarks",
  "wrapper": "ScrollTest-module__UkQ3Fq__wrapper",
});
